import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../common/i18n/en.json";

// Detect locale from the first URL path segment.
const detectLangFromPath = () => {
  const parts = window.location.pathname.split("/").filter(Boolean);
  return parts[0] || "en";
};

const LANG_LOADERS = {
  cs: () => import("../common/i18n/cs.json"),
  da: () => import("../common/i18n/da.json"),
  de: () => import("../common/i18n/de.json"),
  "en-uk": () => import("../common/i18n/en-uk.json"),
  "es-419": () => import("../common/i18n/es-419.json"),
  "es-es": () => import("../common/i18n/es-es.json"),
  "es-mx": () => import("../common/i18n/es-mx.json"),
  "es-us": () => import("../common/i18n/es-us.json"),
  es: () => import("../common/i18n/es.json"),
  fi: () => import("../common/i18n/fi.json"),
  fr: () => import("../common/i18n/fr.json"),
  it: () => import("../common/i18n/it.json"),
  ko: () => import("../common/i18n/ko.json"),
  nb: () => import("../common/i18n/nb.json"),
  nl: () => import("../common/i18n/nl.json"),
  pl: () => import("../common/i18n/pl.json"),
  pt: () => import("../common/i18n/pt.json"),
  "pt-br": () => import("../common/i18n/pt-br.json"),
  ro: () => import("../common/i18n/ro.json"),
  ru: () => import("../common/i18n/ru.json"),
  sv: () => import("../common/i18n/sv.json"),
  tr: () => import("../common/i18n/tr.json"),
  xx: () => import("../common/i18n/xx.json"),
  "zh-cn": () => import("../common/i18n/zh-cn.json"),
  ja: () => import("../common/i18n/ja.json"),
};

const rawLang = detectLangFromPath();
const currentLang = rawLang === "en" || LANG_LOADERS[rawLang] ? rawLang : "en";

if (initReactI18next) {
  i18n.use(initReactI18next);
}

i18n.init({
  lng: currentLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  resources: {
    en: { translation: en },
  },
});

// Lazy-load the detected language bundle (English is already inline above)
if (currentLang !== "en" && LANG_LOADERS[currentLang]) {
  LANG_LOADERS[currentLang]().then((module) => {
    const data = module.default || module;
    i18n.addResourceBundle(currentLang, "translation", data, true, true);
    i18n.changeLanguage(currentLang);
  });
}

export default i18n;
